function initializeSwiper() {
  new Swiper(".product-image-list-slider", {
    slidesPerView: "auto",
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    freeMode: true,
  });
}

// On first page load
document.addEventListener("DOMContentLoaded", function () {
  initializeSwiper();
});

// On Shopify section reload
document.addEventListener("shopify:section:load", function (event) {
  if (event.detail.sectionId === "{{ section.id }}") {
    setTimeout(function () {
      initializeSwiper();
    }, 500);
  }
});
